<template>
  <AppLink :to="to" class="flex items-center text-sm uppercase">
    <svg-icon
      name="chveron-right"
      width="16"
      height="16"
      :class="{ 'transform rotate-180': $i18n.locale === 'en' }"
      class="transform text-primary-800 fill-current mr-3"
    />

    <slot />
  </AppLink>
</template>
<script setup lang="ts">
defineComponent({
  name: 'Back',
});

defineProps({
  to: {
    type: String,
    default: '/',
  },
});
</script>
<i18n>
{
    "en": {
        "backToCart": "Back"
    },
    "ar": {
        "backToCart": "الرجوع"
    }
}
</i18n>
